import { render } from "./Vision.vue?vue&type=template&id=56bf7d41&scoped=true"
import script from "./Vision.vue?vue&type=script&lang=js"
export * from "./Vision.vue?vue&type=script&lang=js"

import "./Vision.vue?vue&type=style&index=0&id=56bf7d41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bf7d41"]])

export default __exports__